export const SUBSCRIBE_TO_USER_STATUS = "SUBSCRIBE_TO_USER_STATUS";
export const subscribeToUserStatus = (userId) => async (dispatch) => {
    return dispatch({
        type: SUBSCRIBE_TO_USER_STATUS,
        userId,
    });
};
